<!--
확장형 input 추상 컴포넌트
기본 input 컴포넌트를 자식으로 소유하고있고, 
input 요소 주변에 여러기능들이 부가적으로 추가된 구조

상속받아 템플릿 정의를 다시하면 됨. 
-------------------------------
추가 기능
  - 라벨
  - 오류메세지
  - 설명메세지
  - 필수값 표시
-->
<script>
    export default {
         // v-model 처리
        model: {
            prop: 'value',
            event: 'update:value'
        },
        props: {
            /**
             * 하위 컴포넌트 전달용
             */
            id: String,
            name: String,
            placeholder: {
                type: String,
                default: ''
            },
            // app-input-fixed 에서만 사용됨
            text: {
                type: String,
                default: ''
            },
            value: {
                type: [String, Number],
                default: ''
            },
            inputSize: {
                type: String,
                default: null
            },
            validateRules: {
                default: null
            },
            options: {
                type: Array,
                default: null
            },
            initErrorMsg: {
                type: String,
                default: null
            },
            textareaRows: { 
                type: Number,
                default: 5
            },
            readonly: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },


            /**
             * input 컴포넌트 종류
             */
            type: {
                type: String,
                default: 'text'
            },
            /**
             * 라벨
             */
            label: {
                type: String,
                default: ''
            },

            /**
             * 강조여부
             * 필수값이 아닌 주요 필드를 강조할때 사용
             * */
            highlight: {
                type: Boolean,
                default: false
            },

            /**
             * 필수값 여부
             * */
            required: {
                type: Boolean,
                default: false
            },
            /**
             * 필수값 안내 텍스트
             * */
            requiredText: {
                type: String,
                default: '*'
            },
            /**
             * 필수값 안내 위치
             *  - 'label-left' : 라벨 왼쪽
             *  - 'label-highlight' : 라벨자체를 눈에띄게 강조
             *  - 'label-right-sup' : 라벨 우측 위로 조그맣게
             *  - 'input-bottom' : input 요소 밑에
             * */
            requiredLayout: {
                type: String,
                default: 'label-right-sup'
            },
            /**
             * 설명 메세지
             */
            descMsg: {
                type: String,
                default: null
            },

            /**
             * css 변수정의
             * 전달 예 :
             * <app-input-ex :css-variables="{'--label-highlight-bg-color': 'red'}" />
             */
            cssVariables: {
                type: Object,
                default: () => { return {}; }
            },

            /**
             * multiselect 컴포넌트에 전달될 클래스명
             */
            multiselectClass: {
                type: String,
                default: null,
            },
        },
        data: function () {

            return {
                /**
                 * 검증상태
                 */
                validateState: null,
                /**
                 * 오류메세지
                 */
                errorMsg: null,
                /**
                 * 포커싱 상태
                 */
                isFocus: false,
            };
        },
        computed: {

            /**
             * 디폴트 css 변수정의
             */
            defaultCssVariables: function () {
                return {
                };
            },

            /**
             * 라벨 클래스 명
             * */
            labelClassObject: function () {
                return {
                    'label-small': this.inputSize === 'small',
                    'label-large': this.inputSize === 'large',
                    'label-focus': this.isFocus,
                }
            },
        },
        methods: {
            /**
             * input 컴포넌트의 setFocus 호출
             * */
            inputFocus: function () {
                this.$refs.input.inputFocus();
            },
            /**
             * input 컴포넌트의 setState 호출
             * @param state 상태
             *          - 'ing'
             *          - 'success'
             *          - 'error'
             * @param errmsg  오류메세지
             */
            setState: function (state, errmsg) {
                this.$refs.input.setState(state, errmsg);
            },
            /**
             * input 컴포넌트의 값 변경 이벤트 리스너
             * @param val 변경된값
             * */
            updateValue: function (val) {
                this.$emit('update:value', val);
            },
            /**
             * input 컴포넌트의 검증상태 변경 이벤트 리스너
             * @param state 상태
             * @param msg 오류메세지
             * */
            updateState: function (state, msg) {
                this.validateState = state;
                this.errorMsg = msg;
            },
            /**
             * input 컴포넌트의 포커스상태 변경 이벤트 리스너
             * @param bool 상태
             * */
            updateIsFocus: function (bool) {
                this.isFocus = bool;
            },
            
        }, 
    }
</script>
